<template>
  <main id="main">
    <template v-if="category">
      <CategoryHeader :category="category" />
      <SectionsRenderer v-if="category.sections" :sections="category.sections" />
    </template>
    <Transition name="fade">
      <Loader v-if="!category" />
    </Transition>
  </main>
</template>

<script>
import { CategoryHeader } from '@/components/sections'
import SectionsRenderer from '@/components/SectionsRenderer.vue'
import { Loader } from '@/components/small'
import { HasCategory } from '@/mixins'

export default {
  name: 'Category',
  mixins: [HasCategory],
  components: { CategoryHeader, Loader, SectionsRenderer },
  beforeMount() {
    if (!this.$store.getters.categoriesSlugMap[this.$route.params.slug])
      this.$router.push({ name: 'home' })
  },
  computed: {
    category() {
      const categoryID = this.$store.getters.categoriesSlugMap[this.$route.params.slug]

      return this.getCategory(categoryID ?? 0)
    },
  },
  watch: {
    category: {
      handler() {
        if (this.category) this.$store.dispatch('updateCategorySeo', this.category)
      },
      immediate: true,
    },
  },
}
</script>
